import { CellProps } from 'react-table';
import { OffersTableRow } from '../common/types/OfferTable.types';
import { getPricePerMonth } from '../common/utils/OfferPage.utils';
import { PropertyImage } from 'components/atoms/PropertyImage/PropertyImage';
import { PropertyCellProps } from '../../common/components/table/renter-table.types';

export const OffersPropertyCell = <T extends object = OffersTableRow>({ value }: CellProps<T, PropertyCellProps>) => {
  const { location, price, image, unitNumber, isMulti } = value;
  return (
    <div className='flex gap-3 items-center'>
      <div className='w-[64px] h-[48px] min-w-[64px]'>
        <PropertyImage image={image} />
      </div>
      <div className={'text-sm'}>
        <div>{location}</div>
        {isMulti && <div>{`(Unit ${unitNumber})`}</div>}
        <p className='text-trueGray'>{getPricePerMonth(price)}</p>
      </div>
    </div>
  );
};
